import moment from 'moment';

const startDate = moment().subtract(30, 'days');
const currentDate = moment();

const schema = {
    rangeDate: {
        id: 'rangeDate',
        label: 'Período',
        placeholder: '',
        type: 'daterange',
        required: true,
        value: [startDate, currentDate],
    },
    type: {
        id: 'type',
        label: 'Tipo',
        required: true,
        type: 'select',
        options: [
            {
                codigo: 'F',
                nome: 'Futuras',
            },
            {
                codigo: 'R',
                nome: 'Realizadas',
            },
        ],
        value: 'F',
    }
};

export default schema;
